import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData, VerifyData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import { useLocation } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import BillPrint from '../Sale/Print';
import ReactDOM from 'react-dom';


const SaleDraftDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);
    const [SaleDraftId, setSaleDraftId] = useState({});
    const location = useLocation();
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    useEffect(() => {
        fetchData('SaleDraftApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.SaleDraft);
                    setSaleDraftId(response.response_data.SaleDraft.Id);
                    setSelectedItems(response.response_data.SaleDetailsDraft);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;
    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [showModal, setShowModal] = useState(false);
    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const [isModalOpenverify, setIsModalOpenverify] = useState(false);
    const openModalverify = () => setIsModalOpenverify(true);
    const closeModalverify = () => setIsModalOpenverify(false);

    const handleVerifyPurchaseOrder = (SaleDraftId) => {
        VerifyData('SaleDraftApi', `${SaleDraftId}`, token)
            .then((response) => {

                if (response.response === 'Sale Converted') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }
                history.push("/SaleIndex");
            })
            .catch((error) => {
                console.error('Error Converted to Purchase record:', error);
            });
    };

    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        if (location.state?.from === '/SaleIndex' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
    }, [location]);

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Sale Draft Details
                </h6>

                <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>

                    <div
                        className="flex items-center w-full sm:w-auto sm:ml-4"
                        style={{ marginRight: '120px', marginTop: '20px' }}
                    >
                        <label
                            className="uppercase block tracking-wide font-bold mr-2"
                            style={{
                                color: 'green',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '8px',
                                border: '0px solid green',
                                borderRadius: '5px',
                            }}
                        >
                            <input
                                type="radio"
                                name="BillType"
                                value="1"
                                checked={formData.BillType === 1}
                                style={{
                                    marginRight: '5px',
                                    width: '16px',
                                    height: '16px',
                                    cursor: 'pointer',
                                }}
                                disabled
                            />
                            Wholesale
                        </label>
                        <label
                            className="uppercase block tracking-wide font-bold mr-2"
                            style={{
                                color: 'blue',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '8px',
                                border: '0px solid blue',
                                borderRadius: '5px',
                            }}
                        >
                            <input
                                type="radio"
                                name="BillType"
                                value="2"
                                checked={formData.BillType === 2}
                                style={{
                                    marginRight: '5px',
                                    width: '16px',
                                    height: '16px',
                                    cursor: 'pointer',
                                }}
                                disabled
                            />
                            Retail
                        </label>
                        <label
                            className="uppercase block tracking-wide font-bold"
                            style={{
                                color: 'brown',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '8px',
                                border: '0px solid brown',
                                borderRadius: '5px',
                            }}
                        >
                            <input
                                type="radio"
                                name="BillType"
                                value="3"
                                checked={formData.BillType === 3}
                                style={{
                                    marginRight: '5px',
                                    width: '16px',
                                    height: '16px',
                                    cursor: 'pointer',
                                }}
                                disabled
                            />
                            BtoC
                        </label>
                    </div>

                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
                            Total Item Count :
                            <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
                                {selectedItems.length}
                            </span>
                        </label>
                    </div>

                    <div>
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px' }}>
                            Total QTY :
                            <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
                                {formData.TotalQuantity}
                            </span>
                        </label>
                    </div>
                </div>

                <div className="flex mt-8 w-full sm:w-auto">

                    
                    <Button
                        // style={{ marginLeft: '8px', color: 'darkgreen' }}
                        style={{
                            background: 'linear-gradient(to right ,#9EDF9C,#9EDF9C)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '25px',
                            //marginLeft: '5px',
                            marginLeft: '10px',

                        }}
                        disabled={isLoading}
                        onClick={openModalverify}
                    >
                        <ArrowForwardIcon style={{ color: '#17153B', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>To Sale</b>}
                    </Button>


                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: `/SaleDraftEdit/${id}`,
                            state: { from: "/SaleDraftDetails" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                        // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                        style={{
                            background: 'linear-gradient(to right, #ECFFE6,#ECFFE6)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '25px',
                            //marginLeft: '5px',
                            marginLeft: '10px',

                        }}
                    >
                        <EditIcon style={{ color: 'black', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Edit</b>
                    </Button>

                    <Button
                        style={{
                            background: 'linear-gradient(to right ,#BEEEF7,#BEEEF7)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '25px',
                            //marginLeft: '5px',
                            marginLeft: '8px',

                        }}
                        disabled={isLoading}
                        onClick={opendatamodal}
                    >
                        <ImportExportIcon style={{ color: 'darkmagenta', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Export</b>}
                    </Button>
                    
                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/SaleIndex",
                            state: { from: "/SaleDraftDetails" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                        // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                        style={{
                            background: 'linear-gradient(to right, #F1D3CE,#F1D3CE)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '25px',
                            //marginLeft: '5px',
                            marginLeft: '10px',

                        }}
                    >
                        <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Back</b>
                    </Button>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <Modal open={isModalOpenverify} onClose={closeModalverify} style={{ marginTop: '10%' }}>
                    <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                        <h5>Convert to Sale   🤔!</h5>
                        <p>Are you sure , You want to Convert this Data ?</p>
                        <Button
                            style={{ margin: '8px', color: 'darkgreen' }}
                            onClick={() => handleVerifyPurchaseOrder(SaleDraftId)}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Convert</b>}
                        </Button>
                        <Button
                            style={{ margin: '8px', color: 'brown' }}
                            onClick={closeModalverify}
                        >
                            <b>Cancel</b>
                        </Button>
                    </div>
                </Modal>

                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Customer Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.CustomerName}
                                type="text"
                                placeholder="CustomerName"
                                name='CustomerName'
                                disabled
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Type
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceTypeName}
                                type="text"
                                placeholder="InvoiceTypeName"
                                name='InvoiceTypeName'
                                disabled
                            />
                        </div>


                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Sale Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                name='BillDate'
                                disabled
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Sale Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                disabled
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Sales Man
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.SalesManName}
                                type="text"
                                placeholder="SalesManName"
                                name='SalesManName'
                                disabled
                            />

                        </div>

                    </div>


                    <div className="w-full mb-2 flex" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '10px', height: '45%' }}>

                        <div className="w-1/3 mr-2" style={{ marginTop: '15px', marginLeft: '20px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Amount :
                                <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
                            </label>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    R.Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff}
                                    type="text"
                                    placeholder="RoundOff"
                                    style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                    name='RoundOff'
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Dis : <span style={{ color: 'green', fontSize: '14px' }}>{formData.DiscountAmount}</span>
                            </label>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GrandTotal}
                                    type="text"
                                    placeholder="GrandTotal"
                                    style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                    name='GrandTotal'
                                    disabled
                                />
                            </div>


                        </div>

                        <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                CGST :  <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                            </label>

                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CashAmount}
                                    type="number"
                                    placeholder="CashAmount"
                                    style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                    name='CashAmount'
                                    max={formData.GrandTotal}
                                    min="0"
                                    disabled
                                />
                            </div>

                        </div>



                        <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                SGST :
                                <span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>

                            </label>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Card
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CardAmount}
                                    type="number"
                                    placeholder="CardAmount"
                                    style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                    name='CardAmount'
                                    max={formData.GrandTotal}
                                    min="0"
                                    disabled
                                />
                            </div>

                        </div>


                        <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                IGST: <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>

                            </label>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    UPI
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.UPIAmount}
                                    type="number"
                                    placeholder="UPIAmount"
                                    style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                    name='UPIAmount'
                                    max={formData.GrandTotal}
                                    min="0"
                                    disabled
                                />
                            </div>

                        </div>



                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber"
                                style={{ marginLeft: '-20px' }}>
                                Freight  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.FreightGSTRate}%</span> <span style={{ marginLeft: '5px', color: 'red', fontWeight: 'bold' }}>{formData.FreightGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.FreightAmount}
                                type="text"
                                placeholder="FreightAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                name='FreightAmount'
                                min="0"
                                disabled
                            />


                            <div className="w-full mr-2 relative" style={{ marginTop: '12px' }}>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.BalanceAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.BalanceAmount > 0 ? 'red' : 'inherit', // Highlight in red if BalanceAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="BalanceAmount"
                                    placeholder="Balance Amount"
                                    disabled
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                    }}
                                >
                                    Bal.
                                </span>
                            </div>

                        </div>

                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber"
                                style={{ marginLeft: '-20px' }}>
                                Packing  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.PackingGSTRate}%</span> <span style={{ marginLeft: '5px', color: 'red', fontWeight: 'bold' }}>{formData.PackingGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.PackingAmount}
                                type="text"
                                placeholder="PackingAmount"
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                name='PackingAmount'
                                min="0"
                                disabled
                            />
                            <div className="w-full mr-3" style={{ marginTop: '8px', width: '180%' }}>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Remarks"
                                    name="Remarks"
                                    rows={3}
                                    value={formData.Remarks}
                                    style={{ textAlign: 'left', fontWeight: 'bold', height: '50px' }}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                TCS
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.TCSAmount}
                                type="number"
                                placeholder="TCS Amount"
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
                                name='TCSAmount'
                                min="0"
                                disabled
                            />
                        </div>


                    </div>

                    {/* Purchase Order Table */}
                    <div className="w-full mb-2" style={{ marginTop: '15px', overflow: 'auto' }}>
                        <table
                            className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                            style={{ borderCollapse: 'collapse' }}
                        >
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>ITEM NAME</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>BATCH</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>NW</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>GW</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>QTY</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>RATE</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>AMOUNT</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS %</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS ₹</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TAXABLE</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GST ₹</th>
                                    <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TOTAL</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, index) => {
                                    return (
                                        <tr key={index} className="border-b"
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                borderBottom: '1px solid #E0E0E0',
                                                transition: 'transform 0.2s ease-in-out',
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >
                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '35px' }}>
                                                {index + 1}

                                            </td>
                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '130px' }}>{item.ItemName}</td>
                                            <td
                                                style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '130px' }}
                                            >
                                                {`${item.BatchNumber} | Exp. Date: ${formatDateForInput(item.ExpirydDate)}`}
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.NetWeight || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FFCF96', textAlign: 'right' }}
                                                    type="number"
                                                    name="NetWeight"
                                                    min={0}
                                                    readOnly
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.GrossWeight || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D0F288', textAlign: 'right' }}
                                                    type="number"
                                                    name="GrossWeight"
                                                    min={0}
                                                    readOnly
                                                />
                                            </td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    type="number"
                                                    value={item.Quantity}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
                                                    min="0"
                                                    aria-label={`Order quantity for item ${item.Id}`}
                                                    name="Quantity"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.Rate || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#CBE4DE', textAlign: 'right' }}
                                                    type="number"
                                                    name="Rate"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.Amount || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    name="Amount"
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.DiscountPercentage || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                    type="number"
                                                    name="DiscountPercentage"
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.DiscountAmount || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.TaxableAmount || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '65px' }}>
                                                <input
                                                    value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                    className="px-1 py-1 border rounded-md"
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                        width: '70%', // Adjust the width to fit
                                                    }}
                                                    readOnly
                                                />
                                                <span style={{ marginLeft: '3px', color: 'darkmagenta', fontSize: '11px', fontWeight: 'bold', }}>
                                                    {item.GSTRate ? parseFloat(item.GSTRate).toString() : 0}%
                                                </span>
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '45px' }}>
                                                <input
                                                    value={item.TotalAmount || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                />
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>

            {showModal && (
                <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10 ">

                        <div className=" p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px', backgroundColor: '#FFFFFF' }}>
                            <div className="flex justify-end mt-2">
                                <button className="close-button md:static md:mr-2" onClick={closeDataModal} style={{ marginTop: '-10px', color: 'black' }}>
                                    <Tooltip title="Close">
                                        <FaTimes />
                                    </Tooltip>
                                </button>
                            </div>
                            <h6 style={{ textAlign: 'center', fontWeight: 'bold', color: '#B8001F' }}>EXPORT  DETAILS</h6>

                            <div className="w-full mb-2 flex" style={{ marginTop: '20px' }}>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                        Pre-Carriage By
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PreCarriageBy}
                                        type="text"
                                        placeholder="Pre-Carriage By"
                                        name='PreCarriageBy'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />
                                </div>
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                        Place of Receipts Pre-Carrier
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PlaceofReceiptsPreCarrier}
                                        type="text"
                                        placeholder="Place of Receipts Pre-Carrier"
                                        name='PlaceofReceiptsPreCarrier'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Vessel/FlightNo
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.VesselOrFlightNo}
                                        type="text"
                                        placeholder="Vessel / FlightNo"
                                        name='VesselOrFlightNo'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Port of Loading
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PortofLoading}
                                        type="text"
                                        placeholder="Port of Loading"
                                        name='PortofLoading'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>
                            </div>

                            <div className="w-full mb-2 flex" >

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Port of Discharge
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PortofDischarge}
                                        type="text"
                                        placeholder="Port of Discharge"
                                        name='PortofDischarge'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Place of Delivery
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PlaceofDelivery}
                                        type="text"
                                        placeholder="Place of Delivery"
                                        name='PlaceofDelivery'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Country of Origin
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CountryofOrigin}
                                        type="text"
                                        placeholder="Country of Origin"
                                        name='CountryofOrigin'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Country of Destination
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CountryofDestination}
                                        type="text"
                                        placeholder="Country of Destination"
                                        name='CountryofDestination'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                            </div>

                            <div className="w-full mb-2 flex" >

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Marks & Nos
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.MarksandNos}
                                        type="text"
                                        placeholder="MarksandNos"
                                        name='MarksandNos'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        AD Code
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ADCode}
                                        type="text"
                                        placeholder="AD Code"
                                        name='ADCode'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        LUT Number
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.LUTNumber}
                                        type="text"
                                        placeholder="LUT Number"
                                        name='LUTNumber'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        LUT Date
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.LUTDate)}
                                        type="date"
                                        placeholder="LUTDate"
                                        name='LUTDate'
                                        disabled
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default SaleDraftDetails;
